import React from "react";

import RedirectToErrorPage from "./RedirectToErrorPage";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // Log error to a logging service
    console.log(error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // Render fallback UI
      return <RedirectToErrorPage />;
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
